import { isFilledInputs } from "../js/popups/activate_forms";

const resetInputs = (obj) => {
    for (let key in obj) {
        if (typeof obj[key] === 'object' && obj[key] !== null) {
            resetInputs(obj[key]);
        } else {
            obj[key] = false;
        }
    }
}

const resetSignUpSteps = () => {
    const firstStep = document.querySelector('#SignUp .first-step-section');
    const secondStep = document.querySelector('#SignUp .second-step-section');
    const progressIndicator = document.querySelector('.progress-indicator');
    const progressIndicatorLine = document.querySelector('.progress-indicator-line');
    const progressIndicatorInactive = document.querySelector('.progress-indicator_inactive');
    const banner = document.querySelector('#SignUp .popup__banner');
    const button = document.querySelector('#signup-form-submit-button');
    if (!firstStep.classList.contains('is__active')) {
        secondStep.classList.remove('is__active');
        firstStep.classList.add('is__active');
        [progressIndicator, progressIndicatorLine, progressIndicatorInactive, banner].forEach((elem) => {
            elem?.classList.remove('second-step');
        });
        progressIndicator.removeEventListener('click', resetSignUpSteps);
        button.disabled = false;
    }
}

const closeAllPopups = () => {
    document.querySelectorAll('[data-popup].is__open').forEach((openPopup) => {
        openPopup.classList.remove('is__open');
        if (openPopup.dataset.sport) {
            openPopup.removeAttribute('data-sport');
        }
        const forms = document.querySelectorAll('form');
        forms.forEach((form) => form.reset());
        resetInputs(isFilledInputs);
        const errors = document.querySelectorAll('.error__message');
        const dateErrors = document.querySelectorAll('.signup__birthdate__row .error-message');
        [...errors, ...dateErrors].forEach((error) => {
            error.innerHTML = '';
            error.classList.remove('show');
        });
        const hintPasswordElements = document.querySelectorAll('.signup-hint-password');
        hintPasswordElements.forEach((hint) => {
            hint.classList.remove('success');
            hint.classList.remove('unsuccessful');
        });
        resetSignUpSteps();
        const signUpButton = document.querySelector('#signup-form-submit-button');
        const loginButton = document.querySelector('#login-form-submit-button');
        signUpButton.disabled = true;
        loginButton.disabled = true;
        const modalFromUrl = getQueryParamFromUrl('modal');
        if (modalFromUrl) {
            removeQueryParamFromUrl('modal');
        }
    });
};

const openPopupById = (popupId, product = 'casino') => {
    const popup = document.getElementById(popupId);
    if (popup) {
        const banner = popup.querySelector('.popup__banner');
        if (product === 'sport' && popupId === 'SignUp') {
            popup.dataset.sport = true;
            banner.src = './assets/images/sport-default.jpg';
        } else if (product === 'casino' && popupId === 'SignUp') {
            banner.src = './assets/images/casinoDefault.jpg';
        }
        popup.classList.add('is__open');
        addQueryParamToUrl('modal', popupId);
    }
};

const getQueryParamFromUrl = (key) => {
    const params = new URLSearchParams(window.location.search);
    return params.get(key);
}

const addQueryParamToUrl = (key, value) => {
    const params = new URLSearchParams(window.location.search);
    params.set(key, value);
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.pushState(1, null, newUrl);
};

const removeQueryParamFromUrl = (key) => {
    const params = new URLSearchParams(window.location.search);
    params.delete(key);
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.pushState(1, null, newUrl);
};

const checkIfAuthPopup = (popupId) => {
    return popupId === 'SignUp' || popupId === 'Login' || popupId === 'ForgotPassword';
};

export {
    resetSignUpSteps,
    closeAllPopups,
    openPopupById,
    removeQueryParamFromUrl,
    getQueryParamFromUrl,
    checkIfAuthPopup
};
